// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3yVAi","signatureBlock":"Footer_signatureBlock__1MGsJ","signature":"Footer_signature__1fHeo"};